export enum MedcardStatus {
  Protected = 'protected',
  NeedConfirmation = 'need_confirmation',
  Expired = 'expired',
  Available = 'available'
}
